import React, { useState } from 'react';
import { Form as FinalForm } from 'react-final-form';

import FormInput from '../../../Form/InputFieldV2/FormInput';
// @ts-expect-error Allow JS import
import ButtonV2 from '../../../Button/ButtonV2';
// @ts-expect-error Allow JS import
import Link from '../../../Link/Link';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as Validations from '../../../Form/util/validations';
import useAuthErrorHandler from '../../../../hooks/useAuthErrorHandler';
import {
  verify2FA,
  resend2FA,
  verifyAction2FA,
  resendAction2FA,
} from '../../../../actions/AuthActions';

import containerStyles from '../../AuthForms.module.less';

type TwoFactorFormProps = {
  notifiedValue: string; // SMS or email that the code was sent to
  sessionId?: string; // required for login
  userObjectId?: string; // partiallyLoggedInUserId for login
  isLogin?: boolean; // Flag if for login
  verificationCopy?: string; // For 2fa actions, copy will be provided in the error message for the modal
  verifiedCallback: () => void; // Callback after successful verification
};

const TwoFactorForm: React.FC<TwoFactorFormProps> = ({
  notifiedValue,
  sessionId = '',
  userObjectId = '',
  isLogin = false,
  verificationCopy,
  verifiedCallback,
}) => {
  const [errorMessage, handleError] = useAuthErrorHandler();
  const [resendMessage, setResendMessage] = useState('');

  const onSubmit = ({ code }: { code: string }) =>
    isLogin
      ? verify2FA(code, userObjectId, sessionId).then(verifiedCallback).catch(handleError)
      : verifyAction2FA(code).then(verifiedCallback).catch(handleError);

  const onResendCode = () =>
    isLogin
      ? resend2FA(userObjectId, sessionId)
          .then(() => setResendMessage('Your code has been resent.'))
          .catch(handleError)
      : resendAction2FA()
          .then(() => setResendMessage('Your code has been resent.'))
          .catch(handleError);

  const prompt = isLogin
    ? 'To log in, enter the code sent to'
    : verificationCopy || `To continue, enter the code sent to`;

  return (
    <FinalForm onSubmit={onSubmit}>
      {({ handleSubmit, submitting, valid }) => (
        <>
          <h1 className={containerStyles.title}>Enter your verification code</h1>
          <p className={containerStyles.textCenter}>
            {prompt} <strong>{notifiedValue}</strong>
          </p>
          <form data-testid="zui-2fa" onSubmit={handleSubmit}>
            <FormInput
              className={containerStyles.field}
              name="code"
              type="text"
              label="Code"
              id="zui-2fa__code"
              data-testid="zui-2fa__code"
              required
              validate={[Validations.REQUIRED]}
              autoComplete="one-time-code"
              inputMode="numeric"
            />
            <ButtonV2
              disabled={!valid || submitting}
              fullWidth
              type="submit"
              className={containerStyles.submit}
            >
              Verify
            </ButtonV2>
          </form>
          {errorMessage && (
            <div className={containerStyles.error}>
              {errorMessage ||
                'There was a problem processing your request. Please try again or contact customer support for assistance.'}
            </div>
          )}
          <div className={containerStyles.textCenter}>
            Didn&apos;t receive a code? {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link role="button" onClick={onResendCode} inline>
              Click here
            </Link>{' '}
            to resend.{' '}
          </div>
          {resendMessage && <p className={containerStyles.textCenter}>{resendMessage}</p>}
        </>
      )}
    </FinalForm>
  );
};

export default TwoFactorForm;
